import * as yup from "yup";
import { useDictionary } from "hooks/use-dictionary";
import { interpolate } from "utils/interpolate";

type FormDictionary = ReturnType<typeof useDictionary>["form"];

export const passwordSchema = (dict: FormDictionary) =>
  yup
    .string()
    .matches(/[A-Z]/, dict.uppercaseRequiredError)
    .matches(/[a-z]/, dict.lowercaseRequiredError)
    .matches(/[0-9]/, dict.numberRequiredError)
    .min(8, interpolate(dict.minSymbolsError, { value: 8 }))
    .required(dict.requiredError);

export const confirmPasswordSchema = (dict: FormDictionary, passwordFieldName: string) =>
  yup
    .string()
    .required(dict.requiredError)
    .test("", "", (value, ctx) => {
      if (ctx.parent[passwordFieldName] !== value) {
        return ctx.createError({ message: dict.passwordsDontMatch });
      }
      return true;
    });
